"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketLoggingInput_1 = require("./PutBucketLoggingInput");
var PutBucketLoggingOutput_1 = require("./PutBucketLoggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketLogging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketLogging",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?logging"
    },
    input: {
        shape: PutBucketLoggingInput_1.PutBucketLoggingInput
    },
    output: {
        shape: PutBucketLoggingOutput_1.PutBucketLoggingOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketLogging.js.map